export default __webpack_public_path__ + "static/media/5_image_2.4c4fd304.jpg";